import axiosClient from "@/apiClient";
import { extractSessionExpiry } from "@/store/SessionTimer";
import { useAuthStore } from "@/stores/auth";

export const apiUtils = {
  doGet(api, params, options) {
    return axiosClient.get(api, { params, ...options })
      .then(response => apiUtils.handleResponse(api, response))
      .catch(error => apiUtils.handleError(error));
  },
  doPost(api, params) {
    return axiosClient.post(api, params)
      .then(response => apiUtils.handleResponse(api, response))
      .catch(error => apiUtils.handleError(error));
  },
  // Extracted common response handling logic
  handleResponse(api, response) {
    const requiresLogin = response.data.requiresLogin !== undefined ? response.data.requiresLogin : false;
    console.debug(`API Call [${api}]: Requires login - ${requiresLogin}`);

    const authStore = useAuthStore();
    if (authStore.isLoggedIn) {
      if (requiresLogin) {
        authStore.reset();
        return;
      }
      extractSessionExpiry(response.headers["x-session-expiry"]);
    }

    return response.data;
  },
  handleError(error) {
    console.error("API Error:", error);
    throw error;
  }
};
